import { supabase } from "@/api/supabase";

/** What anyone may learn about a tenant before signing in. */
export type TenantPublic = {
  name: string;
  logoPath: string | null;
  themePreset: string | null;
  cardImagePath: string | null;
  status: "active" | "suspended";
};

/** A tenant's public branding by subdomain slug; `null` for a slug that doesn't exist. */
export async function getTenantPublic(slug: string): Promise<TenantPublic | null> {
  const { data, error } = await supabase.rpc("get_tenant_public", { p_slug: slug });
  if (error) {
    throw error;
  }
  const row = data[0];
  if (!row) {
    return null;
  }
  return {
    name: row.name,
    logoPath: row.logo_path,
    themePreset: row.theme_preset,
    cardImagePath: row.card_image_path ?? null,
    status: row.status === "active" ? "active" : "suspended",
  };
}
